export const INVENTARIO_NONE = 0;
export const INVENTARIO_CONCLUIDO = 1;
export const INVENTARIO_ABERTO = 2;
export const INVENTARIO_EM_CONTAGEM = 3;

export const INVENTARIO_ENCERRANDO_1 = 4;
export const INVENTARIO_ENCERRANDO_2 = 5;

export const INVENTARIO_EXPIRADO = 2;
